const vMap = {
  t: { top: 0 },
  m: { top: "50%", transform: "translateY(-50%)" },
  b: { bottom: 0 },
}
const hMap = {
  l: { left: 0 },
  m: { left: "50%", transform: "translateX(-50%)" },
  r: { right: 0 }
};

function getAbsolutePosition(vertical, horizontal) {
  const verticalStyles = vMap[vertical] || {};
  const horizontalStyles = hMap[horizontal] || {};

  // Merge styles and handle transform conflicts
  let styles = { position: "absolute", ...verticalStyles, ...horizontalStyles };

  // Merge transform properties correctly
  if (verticalStyles.transform && horizontalStyles.transform) {
    styles.transform = `${verticalStyles.transform} ${horizontalStyles.transform}`;
  }

  return styles;
}



export default function NodePositionContainer({position,children}){


  let absPos = getAbsolutePosition(position[0],position[1]);



  return (

    <div class="sg-row" 
    style={{
      ...absPos,
    }}>
      {children}
    </div>
  )

}
